module.exports = __webpack_public_path__ + "img/png14.661b0537.png";